<!-- ******************************** USER DATA MODAL ******************************** -->
<template>
  <v-layout xs12 >

<v-btn
class="elevation-0"  color="iotyblue" light


  @click="onSubmitDesign()"

>
request an estimate
</v-btn>

<v-dialog
  v-model="dialog"
  max-width="600px"
>
<v-toolbar class="pt-3 elevation-0 white iotyblue--text" primary-title>
      <v-toolbar-title style="font-size: 1.8em;" class="mx-4">My Profile</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon light @click="dialog = false">
          <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card class="pt-2">
        <v-form ref="form">
        <v-container v-if="selectedProject" pl-5 pr-5 grid-list-lg fluid>
          <v-layout row wrap>
            <v-layout align-center justify-start row fill-height>
              <v-flex xs12>
              <div>
              <v-flex xs12>
                <p class="subheading mb-0">{{selectedProject.name}}</p>
                <p class="body-2 iotygrey--text">{{selectedProject.location}}</p>
              </v-flex>
              </div>
              </v-flex>
            </v-layout>
            <v-text-field v-model="formData.unit" height="20" outline background-color="iotyblue3" label="Your unit" :rules="requiredRule"></v-text-field>
          </v-layout>

          <p class="mb-0 title iotyblue--text">Contact Information   <v-btn  flat class="pa-1" color="iotyblue" small  @click="onOpen">Auto fill</v-btn> </p>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field v-model="formData.firstName" outline background-color="iotyblue3" label="First name" :rules="requiredRule"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="formData.lastName" outline background-color="iotyblue3" label="Last name" :rules="requiredRule"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field  v-model="formData.email" outline background-color="iotyblue3" label="Email"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="formData.phone" outline background-color="iotyblue3" label="Phone" :rules="requiredRule"></v-text-field>
            </v-flex>
          </v-layout>
          <p class="title iotyblue--text">Current Address</p>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-text-field v-model="formData.address" outline background-color="iotyblue3" label="Address" :rules="requiredRule"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="formData.address2" outline background-color="iotyblue3" label="Adress2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>

            <v-flex xs12 sm6 md5>
              <v-text-field v-model="formData.city" outline background-color="iotyblue3" label="City" :rules="requiredRule"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field v-model="formData.state" outline background-color="iotyblue3" label="State" :rules="requiredRule"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field v-model="formData.zip" outline background-color="iotyblue3" label="Zip" :rules="requiredRule"></v-text-field>
            </v-flex>

          </v-layout>
          <v-layout  row wrap>

          </v-layout>
        <v-layout xs12 sm10 offset-(sm10) align-center row >
          <v-flex>
            <v-checkbox v-model="terms" class="pt-0 mt-0" label="Accept Terms and Conditions"></v-checkbox>
          </v-flex>
        </v-layout>
        </v-container>
        <v-card-actions class="pt-2 pr-5 pb-5">
          <v-spacer></v-spacer>
           <v-btn color="iotyblack" flat @click="clearUserDatat">Clear</v-btn>
          <v-btn color="iotyblack" flat @click="$modal.hide('userDataModal')">Cancel</v-btn>
          <v-btn color="iotyblue" class="elevation-0" :disabled='!terms' @click="onNext">Finalize</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
</v-dialog>
    </v-layout>
</template>

<script>
export default {
  data:() => ({
    terms: false,
    formData: {
      unit: '',
      firstName: '',
      lastName: '',
      photoUrl:'',
      email: '',
      phone: '',
      address: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
    },
    dialog:false,
    requiredRule: [
        v => !!v || 'This information is required',
      ],
  }),
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject']
    }
  },

  methods: {
    clearUserDatat(){
      this.formData.unit= ''
       this.formData.firstName= ''
       this.formData.lastName= ''
       this.formData.email= ''
       this.formData.phone= ''
       this.formData.address= ''
       this.formData.address2= ''
       this.formData.city= ''
       this.formData.state= ''
       this.formData.zip= ''
    },
   async onOpen() {
      this.$store.dispatch('autoSignIn')
        await new Promise((resolve, reject) => setTimeout(resolve, 1000))
          .then(()=>{
            let userInfo = this.$store.getters.userData
       this.formData.unit= userInfo.unit
       this.formData.firstName= userInfo.firstName
       this.formData.lastName=  userInfo.lastName
       this.formData.email=  userInfo.email
       this.formData.phone=  userInfo.phone
       this.formData.address=  userInfo.address
       this.formData.address2= userInfo.address2
       this.formData.city=  userInfo.city
       this.formData.state=  userInfo.state
       this.formData.zip=  userInfo.zip
      //  this.formData = { ...this.$store.getters.userData}
      console.log("TCL: onOpen -> this.$store.getters['authuserData']", this.$store.getters.userData)
      console.log("TCL: onOpen -> this.formData", this.formData)
          })
    },
    onNext() {
      if (this.$refs.form.validate()) {
        console.log("TCL: onNext -> this.formData.email", this.formData.email)
        this.$modal.hide('userDataModal')
        this.$store.dispatch('userTranjectionalDataUpdate', this.formData,)
      } else {
        this.$store.dispatch("common/setMessage", {
          text: 'Some of your contact information is missing.',
        icon: 'info_outline',
        color: 'error'
      })
      console.log("TCL: onNext -> else")
      }
    },
    checkForUser() {
      if(this.$store.getters.user) {
        return true
      } else {
        return false
      }
    },
    async onSubmitDesign() {
      if(this.checkForUser()) {
        this.dialog = true
        await this.$modal.show('userDataModal')
      } else {
          await this.$store.commit('common/SET_MENU', true)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/UserData.vue